import React, { Fragment,useEffect } from 'react'
import {GoogleMapContainer, Instruction} from "../index"
import Button from '../../components/Button'
import { ReactComponent as BackButton } from '../../assets/icons/ui/BackButton.svg'
import { useHistory } from "react-router-dom"

const OutageMap = () => {
  const history = useHistory()
  useEffect(()=>{
    window.scrollTo(0, 0)
  },[])
  return(
    <Fragment>
      <Instruction />
      <GoogleMapContainer />
      <div className='outagemap__actions' data-test="outageComponent">
        <p className="map-dangerText">
                A damaged Streetlight can be dangerous. Please contact us to report an emergency at <a className="mapContactNum" href="tel:+18006424272">800 642 4272</a>.
        </p>
        <section className="report-streetlight__actions">
          <Button
            className={`-secondary cancelButton`}
            aria-label={`Cancel and return to homepage`}
            data-a11y-focus="first"
            onClick={() => history.push('/')}
          >
                        Cancel
          </Button>
          <Button
            className={`button -link-button-back -secondary back`}
            aria-label={`Back`}
            data-a11y-focus="first"
            onClick={() => history.push('/OutageWarning')}
          >
            <BackButton/>
          </Button>
        </section>
      </div>
    </Fragment>
  )
}

export default OutageMap
